import { carouselItems } from '@/mocks/home';

const tagColors: Record<string, string> = {
  '新手向': 'bg-accent-100 text-accent-700',
  '盘点': 'bg-primary-100 text-primary-700',
  '画风': 'bg-secondary-100 text-secondary-700',
  '改编': 'bg-accent-100 text-accent-700',
  '追更': 'bg-primary-100 text-primary-700',
};

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">焦点专题</h2>
          <p className="mt-2 text-sm text-foreground-500">精选深度内容，发现韩漫更多可能</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.slice(0, 3).map((item, i) => (
            <div key={i} className="bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:ring-2 hover:ring-primary-200 transition-all">
              <div className="relative overflow-hidden" style={{ aspectRatio: '3/2' }}>
                <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
                <span className={`absolute top-3 left-3 text-xs font-medium px-2.5 py-1 rounded-full ${tagColors[item.tag] || 'bg-background-200 text-foreground-600'}`}>
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-bold font-heading text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {carouselItems.slice(3, 5).map((item, i) => (
            <div key={i + 3} className="bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:ring-2 hover:ring-primary-200 transition-all flex flex-col sm:flex-row">
              <div className="relative overflow-hidden sm:w-2/5" style={{ aspectRatio: '3/2' }}>
                <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
                <span className={`absolute top-3 left-3 text-xs font-medium px-2.5 py-1 rounded-full ${tagColors[item.tag] || 'bg-background-200 text-foreground-600'}`}>
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5 sm:w-3/5 flex flex-col justify-center">
                <h3 className="text-base font-bold font-heading text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}